import React from 'react';
import style from 'assets/jss/material-dashboard-pro-react/views/contactUs/trackingComplaintStyle';
import { makeStyles } from '@material-ui/core';
import { BodyS, DisplayS, BodySBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomInput from 'components/CustomInput/CustomInput';
import CustomButton from 'components/CustomButtons/Button';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import classNames from 'classnames';
import Close from '@material-ui/icons/Close';
import CustomLink from 'components/CustomLink/CustomLink';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import { getLanguage } from 'utils/language/language';
import { upIdSelector } from 'redux/modules/session/selectors';
import { useSelector } from 'react-redux';

// @ts-ignore
const useStyles = makeStyles(style);

interface ITrackTicketProps {
	ticketId: string;
	setTicketId: React.Dispatch<React.SetStateAction<string>>;
	track: () => void;
	error: boolean;
}

const TrackTicket = ({ ticketId, setTicketId, track, error }: ITrackTicketProps) => {
	const classes = useStyles();
	const accId = useSelector(upIdSelector);

	return (
		<div className={classes.trackTicketContent}>
			<ConditionalRender
				show={error}
				onTrue={() => (
					<div className={classes.trackTicketErrorWrapper}>
						<div className={classes.trackTicketErrorTextWrapper}>
							<div className={classNames(classes.oval, classes.ovalError)}>
								<Close />
							</div>
							<DisplayS disableMargin>{translate('contact.tickettracking.error.header')}</DisplayS>
							<div className={classes.trackTicketErrorSubheaderWrapper}>
								<BodyS color="secondary-light" disableMargin>
									{translate('contact.tickettracking.error.subheader')}
								</BodyS>
							</div>
						</div>
					</div>
				)}
				onFalse={() => (
					<div className={classes.trackTicketTextWrapper}>
						<BodyS color="secondary-light">{translate('contact.tickettracking.subheader')}</BodyS>
						<BodySBold color="secondary-light" disableMargin>
							<CustomLink
								to="/dashboard/history-of-complaints"
								color="brand"
								type="bodySBold"
								linkProps={{
									onClick: () =>
										setDataLayer('track_ticket', getLanguage(), null, accId, null, {
											type: 'link',
											link_name: `link:${translate('contact.us.track.ticket.click')}`,
										}),
								}}
							>
								{translate('contact.us.track.ticket.click')}
							</CustomLink>
						</BodySBold>
					</div>
				)}
			/>
			<div className={classes.trackTicketInputContainer}>
				<CustomInput
					labelText={translate('contact.tickettracking.inputTitle')}
					inputProps={{
						onChange: (event: React.FormEvent<HTMLInputElement>) => {
							let _incidentId = (event.target as HTMLInputElement).value;
							setTicketId(_incidentId);
						},
						value: ticketId,
					}}
					formControlProps={{
						fullWidth: true,
					}}
				/>
			</div>
			<div className={classes.trackTicketButtonContainer}>
				<CustomButton color="primary-light" disabled={ticketId.length === 0} onClick={track}>
					{translate('contact.tickettracking.buttonLabel')}
				</CustomButton>
			</div>
		</div>
	);
};

export default TrackTicket;
